// extracted by mini-css-extract-plugin
module.exports = {"button":"ChangeMode_button__xbNCu","active":"ChangeMode_active__1bm_-"};